import React, { useState, useEffect } from "react";
import { Menu, X, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navLinks = [{
    name: "Composite Decks",
    href: "/CompositeTrexDeckBuildersPage"
  }, {
    name: "Pool Decks",
    href: "/PoolDeckContractorsPage"
  }, {
    name: "Structural Decks",
    href: "/StructuralDeckContractorsPage"
  }, {
    name: "Wood Decks",
    href: "/WoodDeckBuildersPage"
  }];
  return <section data-section-id="38700" id="hero-composite-trex-deck-expertise" className="relative h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-secondary/60 z-10" /> {}
        <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/sunset_infinity_pool.png" className="h-full w-full object-cover">
          <source src="/videos/sunset_loop.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/sunset_infinity_pool.png" alt="Modern Trex Transcend deck in Island Mist gray" className="h-full w-full object-cover" />
        </video>
      </div>

      {}
      <header className={`fixed top-0 left-0 z-50 w-full transition-all duration-500 ${isScrolled ? "bg-background/95 backdrop-blur-md shadow-md py-4" : "bg-transparent py-6"}`}>
        <div className="container mx-auto flex items-center justify-between px-6">
          {}
          <Link to="/" className="relative z-50">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/logo.png" alt="PCH Builders" className={`h-8 w-auto object-contain transition-all ${isScrolled ? "brightness-100" : "brightness-0 invert"}`} />
          </Link>

          {}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link, i) => <Link key={i} to={link.href} className={`text-sm font-semibold tracking-wider uppercase transition-colors hover:text-chart-1 ${isScrolled ? "text-foreground" : "text-white"}`} data-index={i}>
                {link.name}
              </Link>)}
            <Button asChild variant="outline" className={`hidden lg:inline-flex rounded-sm border-2 font-bold ${isScrolled ? "border-secondary text-secondary hover:bg-secondary hover:text-white" : "border-white text-white hover:bg-white hover:text-secondary"}`}>
              <Link to="#">Call (925) 529-5005</Link>
            </Button>
          </nav>

          {}
          <Button variant="ghost" size="icon" className={`md:hidden relative z-50 hover:bg-transparent ${isScrolled ? "text-foreground" : "text-white"}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
            {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
          </Button>
        </div>

        {}
        <div className={`fixed inset-0 z-40 flex flex-col items-center justify-center bg-background transition-transform duration-500 md:hidden ${isMobileMenuOpen ? "translate-x-0" : "translate-x-full"}`}>
          <nav className="flex flex-col items-center gap-8">
            {navLinks.map((link, i) => <Link key={i} to={link.href} className="text-2xl font-default font-bold uppercase tracking-tight text-foreground hover:text-chart-1" onClick={() => setIsMobileMenuOpen(false)} data-index={i}>
                {link.name}
              </Link>)}
            <Button className="mt-4 bg-chart-1 text-white rounded-sm px-8 h-12" onClick={() => setIsMobileMenuOpen(false)}>
              Request Free Visit
            </Button>
          </nav>
        </div>
      </header>

      {}
      <div className="relative z-20 flex h-full w-full flex-col items-center justify-center px-4 text-center text-white">
        <div className="relative mb-6 max-w-5xl">
          {}
          <h1 className="font-default text-5xl md:text-7xl lg:text-8xl leading-none font-bold tracking-tighter drop-shadow-2xl">
            Composite & Trex®
            <br />
            <span className="relative inline-block">
              Deck Builders
              {}
              <span className="font-mono text-chart-1 absolute -top-4 -right-12 md:-top-6 md:-right-24 text-sm md:text-base tracking-widest bg-secondary/80 px-3 py-1 rounded-sm border border-chart-1/30 whitespace-nowrap pointer-events-none shadow-xl">
                EST. 1990
              </span>
            </span>
          </h1>
        </div>

        {}
        <p className="font-default mb-12 max-w-2xl text-lg md:text-2xl text-white/90 font-medium tracking-normal drop-shadow-lg">
          The Low-Maintenance, High-Durability Solution for California Homes. Serving SF, Santa Clara, Santa Cruz, and Monterey.
        </p>

        {}
        <Button asChild className="group relative h-16 overflow-hidden rounded-sm bg-chart-1 px-12 text-xl font-bold text-white shadow-xl transition-all hover:scale-105">
          <Link to="#">
            <span className="absolute inset-0 translate-x-[-100%] bg-secondary transition-transform duration-500 ease-out group-hover:translate-x-0" />
            <span className="relative z-10 flex items-center gap-3">
              Get Your Free Estimate
              <ChevronRight className="size-5 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        </Button>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 z-20 -translate-x-1/2 animate-bounce text-white/70">
        <div className="h-12 w-7 rounded-full border-2 border-white/40 flex justify-center pt-2">
          <div className="h-2 w-1 rounded-full bg-chart-1 shadow-[0_0_8px_rgba(166,106,45,0.8)]" />
        </div>
      </div>
    </section>;
}